import { Box, Checkbox } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/Inputs/DayPicker'
import { employeeUser } from 'modules/core/store/collections/users'

import hasRegularAccess from 'modules/employees/lib/hasRegularAccess'
import type BulkEditForm from 'modules/employees/pages/EditInBulk/forms/BulkEdit'
import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  employee: Employee
  bulkEditForm: BulkEditForm
  isChecked: boolean
  onChange: () => void
  onClick: () => void
  width: number
}

const WelcomeSpaceCell = ({
  employee,
  bulkEditForm,
  isChecked,
  onChange,
  onClick,
  width,
}: Props) => {
  const user = employeeUser(employee)
  const confirmed = user.invited && user.joined
  const disabled = confirmed && hasRegularAccess(employee.attributes.has_regular_access)
  const remainingWidth = width - 78

  return (
    <Box
      background="grey000White"
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      height="full"
      paddingX="s16"
      paddingY="s12"
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: 'grey000White',
        },
      }}
      gap="s16"
      style={{ width: `${width}px` }}
    >
      <Box flexNoShrink>
        <Checkbox disabled={disabled} checked={isChecked} onChange={onClick} />
      </Box>
      <Box style={{ width: `${remainingWidth}px` }}>
        <DayPicker
          onChange={onChange}
          field={bulkEditForm.get('regular_access_starts_on')}
          readonly={disabled}
          minDate={moment().startOf('day')}
        />
      </Box>
    </Box>
  )
}

export default observer(WelcomeSpaceCell)
